var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.$apollo.loading ? _c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": "",
      "grid-list-xl": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "wrap": ""
    }
  }, [!_vm._.isEmpty(_vm.digitalContractsSigned) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "text-no-wrap",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.digitalContractsSigned,
      "hide-default-footer": true,
      "mobile-breakpoint": 900,
      "items-per-page": 200
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function (_ref) {
        var header = _ref.header;
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(header.text)
          }
        })];
      }
    }, {
      key: "item.name",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('b', [_vm._v(_vm._s(item.name))])];
      }
    }, {
      key: "item.status",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('b', {
          class: _vm.getStatusColor(item.status)
        }, [_vm._v(" " + _vm._s(_vm.getLocalizedStatus(item.status)) + " ")])];
      }
    }, {
      key: "item.signed_at",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm._f("moment")(item.signed_at, "ll")) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function (_ref5) {
        var item = _ref5.item;
        return [item.url ? _c('a', {
          staticClass: "text-decoration-none",
          attrs: {
            "href": item.url,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('v-btn', {
          attrs: {
            "outlined": "",
            "text": "",
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.view")) + " ")])], 1) : _c('span', {
          staticClass: "text--disabled"
        }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.notAvailable")) + " ")])];
      }
    }], null, false, 1950115331)
  })], 1) : _c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', [_c('v-card', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "50px"
    }
  }, [_c('v-icon', {
    staticClass: "mb-4",
    attrs: {
      "size": "64",
      "color": "grey lighten-1"
    }
  }, [_vm._v(" mdi-ghost ")]), _c('h3', [_vm._v(_vm._s(_vm.$t("digitalContracts.myContracts")))]), _c('p', [_vm._v(_vm._s(_vm.$t("digitalContracts.noContractsDesc")))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }